// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b36f1f0a] .apexcharts-reset-icon {\n  margin-left: 2px;\n  padding-top: 2px;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n[data-v-b36f1f0a] .apexcharts-reset-icon:hover svg path {\n  fill: #000;\n}\n[data-v-b36f1f0a] .apexcharts-zoom-icon {\n  margin-left: -3px;\n}", ""]);
// Exports
module.exports = exports;
